/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { z } from 'zod/v4-mini';
import enLocale from 'zod/v4/locales/en.js';
// Enable parse error messages
z.config(enLocale());
/**
 * Get a Zod object that matches the expected type, including any optional properties.
 * (Does not provide the same guarantee for nested object types.)
 *
 * Unrecognized properties will be stripped/ignored at runtime.
 * To preserve them, use `matchingZodObjectLoose` instead.
 *
 * Using this helper instead of `const ZodFoo = z.object({...}); type Foo = z.infer<typeof ZodFoo>;`
 * is recommended in cases where the original type is defined elsewhere (such as in `common-types`),
 * to ensure all the properties stay in sync.
 */
export function matchingZodObject(shape) {
    return z.object(shape);
}
/**
 * Like `matchingZodObject`, but pass through any extra properties that aren't defined in the shape.
 *
 * See `matchingZodObject` comment for more details.
 */
export function matchingZodObjectLoose(shape) {
    return z.looseObject(shape);
}
//# sourceMappingURL=matchingZodObject.js.map